import { TTintColor, TTintSettings } from 'features/product-info/components/pdp-select-tint-color/types';
import { STAGE } from 'features/product-info/components/pdp-select-tint-color/pdp-select-tint-color.const';
import { handleChangePriceInRobotintModal } from './handle-сhange-price-in-robotint-modal.helper';

type TProps = {
  clientId: string;
  secret: string;
  colorSelect: (color: Required<TTintColor>) => void;
  robotintLink: string;
};

export const getRobotintOptions = ({ clientId, secret, colorSelect, robotintLink }: TProps) => {
  const tintSettings: TTintSettings = {
    CLIENT_ID: clientId,
    SECRET: secret,
    WITH_PRICE: 1,
    USE_SWITCHER: 0,
  };

  if (robotintLink.includes(STAGE)) {
    tintSettings.DOMAIN = robotintLink;
  }

  return {
    tintSettings,
    siteSettings: {
      colorSelect,
      processPrice: handleChangePriceInRobotintModal,
      bgZindex: 10000,
      basketURL: '/basket/',
    },
  };
};
